<div class="center-container">
  <div class="jobcard-header">{{"bikeshop.dashboard.jobcard" | translate }}: #{{ jobCard && jobCard.jobCardNo }}</div>
  <div class="quote-container">
    <ng-container *ngIf="jobCard.invoiceTotal">
      <div class="spaced">
        <div *ngIf="jobCard.preApprovedAmount < jobCard.invoiceTotal.totalPrice">{{ "cyclist.pending_quote" | translate }}</div>
        <div *ngIf="jobCard.preApprovedAmount < jobCard.invoiceTotal.totalPrice">#</div>
      </div>
      <div *ngIf="jobCard.preApprovedAmount < jobCard.invoiceTotal.totalPrice">({{"cyclist.press_to_approve" | translate }})</div>
      <div *ngIf="jobCard.preApprovedAmount >= jobCard.invoiceTotal.totalPrice">{{ "cyclist.quote_pre_approved" | translate}}</div>
      <hr />
    </ng-container>
    <div class="margin-bottom-8 bold" *ngIf="jobCard && jobCard.assessmentNotes && jobCard.assessmentNotes.length>0">
      <h5>{{jobCard.partnerName}}</h5>
    </div>
    <div class="margin-bottom-16 bold" *ngIf="jobCard && jobCard.assessmentNotes && jobCard.assessmentNotes.length>0"
         [innerHtml]="jobCard.assessmentNotes"></div>

    <div style="width: 100%; display:flex; margin-top: 3px;">
      <span class="jobcard-header" style="margin-right: 15px; line-height: 45px;">{{'cyclist.technician_name'| translate}}:</span>
      <span><avatar size=45 name="{{technicianName}}" profilePhoto="{{technicianPhoto}}"></avatar> </span>
      <span style="font-size: 95%;opacity: 0.9; margin-left: 10px; line-height: 45px;">{{technicianName}}</span>
    </div>

    <div class="quote-section-header" *ngIf="showLabourHeading">
      <div>{{'bikeshop.workshop.jobcard.labour' | translate}}</div>
      <div class="quote-section-amount">{{ currencySymbol }}{{ labourAmount | number: '1.2-2' }}</div>
    </div>
    <div class="spaced" *ngFor="let lineItem of lineItems; let i = index" style="margin-bottom: 8px; margin-top: 10px; display: flex;">
      <ng-container *ngIf="lineItem.isNonInventory">
        <div>
          {{ lineItem.name }}
          <div style="font-size: 90%;opacity: 0.8;">
            {{ lineItem.quantity }} x {{ currencySymbol }}{{
 (vatInclusive ?
          lineItem.unitPrice_IncludingTax : lineItem.unitPrice) | number: '1.2-2'
            }} {{
lineItem.discount > 0 ? ('(Total
          Discount ' + currencySymbol + (lineItem.discount | number : '.2-2') +')') : ''
            }}
          </div>
          <div *ngIf="lineItem.lineItemNote" style="font-size: 90%;opacity: 0.8;">*{{lineItem.lineItemNote}}</div>
        </div>
        <div class="spaced" style="margin-left: 16px;">
          <div style="margin-right: 10px;">
            {{ currencySymbol }}{{
 (vatInclusive ? lineItem.unitPrice_IncludingTax :
          lineItem.unitPrice) * lineItem.quantity | number: '1.2-2'
            }}
          </div>
          <p-checkbox [(ngModel)]="approvedList[i]" [binary]="true" [disabled]="lineItem.approved || sent || sentApproval"
                      (click)="approvedItem()"></p-checkbox>
        </div>
      </ng-container>
    </div>

    <br *ngIf="showProductsHeading" />
    <div class="quote-section-header" *ngIf="showProductsHeading">
      <div>{{'bikeshop.workshop.jobcard.parts_and_materials' | translate}}</div>
      <div class="quote-section-amount">{{ currencySymbol }}{{ partsAmount | number: '1.2-2' }}</div>
    </div>
    <div class="spaced" *ngFor="let lineItem of lineItems; let i = index" style="margin-bottom: 8px; margin-top: 10px; display: flex;">
      <ng-container *ngIf="!lineItem.isNonInventory">
        <div>
          {{ lineItem.name }}
          <div style="font-size: 90%;opacity: 0.8;">
            {{ lineItem.quantity }} x {{ currencySymbol }}{{
 (vatInclusive ?
          lineItem.unitPrice_IncludingTax : lineItem.unitPrice) | number: '1.2-2'
            }} {{
lineItem.discount > 0 ? ('(Total
          Discount ' + currencySymbol + (lineItem.discount | number : '.2-2') +')') : ''
            }}
          </div>
          <div *ngIf="lineItem.lineItemNote" style="font-size: 90%;opacity: 0.8;">*{{lineItem.lineItemNote}}</div>
        </div>
        <div class="spaced" style="margin-left: 16px;">
          <div style="margin-right: 10px;">
            {{ currencySymbol }}{{
 (vatInclusive ? lineItem.unitPrice_IncludingTax :
          lineItem.unitPrice) * lineItem.quantity | number: '1.2-2'
            }}
          </div>
          <p-checkbox [(ngModel)]="approvedList[i]" [binary]="true" [disabled]="lineItem.approved || sent || sentApproval"
                      (click)="approvedItem()"></p-checkbox>
        </div>
      </ng-container>
    </div>

    <br />
    <ng-container *ngIf="jobCard.invoiceTotal">
      <button *ngIf="allApproved && !(sentApproval || sent) && (jobCard.preApprovedAmount < jobCard.invoiceTotal.totalPrice)" pButton class="full-width" label="{{ 'cyclist.send_approval' | translate }}"
              (click)="checkSendApproval()"></button>

      <button *ngIf="!allApproved && !(sentApproval || sent) && (jobCard.preApprovedAmount < jobCard.invoiceTotal.totalPrice)" pButton class="full-width" label="{{ 'cyclist.send_partial_approval' | translate }}"
              (click)="checkSendApproval()"></button>

      <button pButton class="full-width" label="{{'cyclist.quote_pre_approved' | translate }}"
              *ngIf="!(sentApproval || sent) && (jobCard.preApprovedAmount >= jobCard.invoiceTotal.totalPrice)"></button>
    </ng-container>
    <div *ngIf="allApproved && (sentApproval || sent)" class="centered approval-sent">
      {{ 'cyclist.approval_sent' | translate }}
    </div>
    <div *ngIf="!allApproved && (sentApproval || sent)" class="centered approval-sent">
      {{ 'cyclist.partial_approval_sent' | translate }}
    </div>

    <div class="totals">
      <div class="seperator"></div>
      <div class="spaced">
        <!--<div>{{vatInclusive ? 'Subtotal (Excl VAT)' : 'Sub-Total'}}:</div>-->

        <div *ngIf="vatInclusive">{{ "cyclist.subtotal" | translate }}:</div>
        <div *ngIf="!vatInclusive">{{ "cyclist.subtotal_excl" | translate }}:</div>
        <div>{{ currencySymbol }}{{ excluding | number: '1.2-2' }}</div>
      </div>
      <div class="spaced" *ngIf="helpersService.showTaxRow(tax, jobCard)">
        <!--<div>{{vatInclusive ? 'VAT' : 'Tax'}}:</div>-->
        <div *ngIf="vatInclusive">{{ "bikeshop.modal.update_job_card.quote.vat" | translate}}:</div>
        <div *ngIf="!vatInclusive">{{"bikeshop.modal.update_job_card.quote.vat" | translate}}:</div>
        <div>{{ currencySymbol }}{{ tax | number: '1.2-2' }}</div>
      </div>
      <div class="spaced" *ngIf="discount > 0">
        <!--<div>{{ vatInclusive ? 'Discount (Incl VAT)' : 'Discount' }}:</div>-->

        <div *ngIf="vatInclusive">{{ "cyclist.discount_incl" | translate}}:</div>
        <div *ngIf="!vatInclusive">{{"bikeshop.modal.update_job_card.quote.discount" | translate}}:</div>
        <div>-{{ currencySymbol }}{{ discount | number: '1.2-2' }}</div>
      </div>
      <div class="seperator"></div>
      <div class="spaced">
        <div> {{ "bikeshop.modal.update_job_card.quote.total" | translate}}:</div>
        <div>{{ currencySymbol }}{{ total | number: '1.2-2' }}</div>
      </div>
    </div>
  </div>

  <div *ngIf="canDoKlarnaPayment">
    <div class="klarna-container">
      <img src="https://hubtiger.blob.core.windows.net/partners/pay_with_klarna_black.png" />
    </div>
    <div class="klarna-message">
      {{"cyclist.klarna_message" | translate}}
    </div>
  </div>

</div>
